import { convertParams } from './convert-params';
import { renderFeatureApp } from './render-feature-app';
import { createFeatureAppId } from './create-feature-app-id';
// will be used for subpath. for example: mypage.html/_ui/technical-data
export const CTD_PATH_ID = 'technical-data';
/**
 *
 * @param featureServices
 * @param appName name of the feature app that should be rendered ('car-technical-details')
 * @param actionId name of the user interaction (ctd--open-feature-app)
 */
export const registerCtdAction = (featureServices, appName, actionId) => {
    const userInteractionService = featureServices['user-interaction-service'];
    const logger = featureServices['s2:logger'];
    const layerManager = featureServices['layer-manager'];
    const featureAppConfiguration = 
    // eslint-disable-next-line security/detect-object-injection
    featureServices['featureapp-service'].featureAppConfigurations[appName];
    const openLayer = (params, featureAppConfiguration) => {
        if (!featureAppConfiguration) {
            logger.warn(`no feature app with name ${appName} found. Cannot open car technical details layer`);
        }
        return layerManager.openContentLayerV2(renderFeatureApp(params, featureAppConfiguration, logger), {}, {
            withoutHeader: true,
            onClose: () => {
                navigator.exit().replace();
            },
        });
    };
    let layer;
    const navigator = userInteractionService.createNavigator(CTD_PATH_ID, createFeatureAppId(featureAppConfiguration));
    // possibly open or close layer when the navigation changes
    navigator.on((uparams) => {
        if (!uparams) {
            if (layer && !layer.isClosed()) {
                layer.close();
            }
        }
        else {
            if (!layer || layer.isClosed()) {
                const params = convertParams(uparams);
                layer = openLayer(params, featureAppConfiguration);
            }
            else {
                logger.warn('params where changed but layer was open already');
            }
        }
    });
    // check if navigator is already active (direct link was opened)
    const params = navigator.getParams();
    logger.debug('ctd layer params during registration', JSON.stringify(params));
    if (params) {
        logger.debug('open ctd layer during registration');
        // this is important for server side and during hydration.
        openLayer(convertParams(params), featureAppConfiguration);
    }
    const userInteractionHandler = userInteractionService.register(actionId, {
        action: (_params, urlParams) => {
            if (!featureAppConfiguration) {
                logger.warn(`no feature app with name ${appName} found. Cannot open car technical details layer`);
                return;
            }
            navigator.navigate(urlParams).replace();
        },
        getHref(_params, urlParams) {
            return navigator.navigate(urlParams).createHref();
        },
    });
    return {
        unbind: () => {
            userInteractionService.unregister(actionId);
            userInteractionHandler.unsubscribe();
            layer === null || layer === void 0 ? void 0 : layer.close();
        },
    };
};
//# sourceMappingURL=v1.js.map